import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import SiteFooter from "../partials/site-footer";
import HelmetWrapper from "../partials/helmet-wrapper";
import SiteHeader from "../partials/site-header";
import WufooForm from "react-wufoo-embed";
import { setInLocal } from "../../utils/app-helpers";

const { siteMetadata: config } = GatsbyConfig;

export default class FinalDetailsPage extends React.Component {
  componentDidMount() {
    const { trip } = this.props;

    setInLocal("lsg.last-viewed-trip", trip);
  }

  render() {
    const { trip, defaultValues, extendedTitle } = this.props;
    const tripData = config.trips[trip];
    const { finalDetailsFormHash, finalDetailsFormEnabled } = tripData;
    const title = `${tripData.name} ${tripData.year} | Final Details`;
    const defaultValuesString = Object.keys(defaultValues || {})
      .map((key) => `${key}=${encodeURIComponent(defaultValues[key])}`)
      .join("&");

    return (
      <div className={`page-finaldetails trip-${trip}`}>
        <HelmetWrapper metaTitle={title} />
        <SiteHeader trip={trip} lock readonly />
        <main>
          <h1 className="colorful">
            {extendedTitle ? (
              <div className="content wrap-small lefta">
                LOVESONG | {tripData.name} {tripData.year} | <br />
                {extendedTitle}
              </div>
            ) : (
              <div className="content wrap-small lefta">
                LOVESONG | {tripData.name} {tripData.year}
              </div>
            )}
          </h1>
          <div className="wrap">
            <div className="wrap-wufoo">
              {finalDetailsFormHash && finalDetailsFormEnabled && (
                <WufooForm
                  userName="lovesonggetaway"
                  formHash={finalDetailsFormHash}
                  header="hide"
                  {...(defaultValuesString
                    ? { defaultValues: defaultValuesString }
                    : null)}
                />
              )}
              {!finalDetailsFormHash && finalDetailsFormEnabled && (
                <div>
                  <p>Form coming soon.</p>
                </div>
              )}
              {!finalDetailsFormEnabled && (
                <div>
                  <p>This form is no longer active.</p>
                </div>
              )}
            </div>
          </div>
        </main>
        <SiteFooter trip={trip} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/finaldetails.js